import { render, staticRenderFns } from "./veStuIdxShow.vue?vue&type=template&id=611b04a8&scoped=true"
import script from "./veStuIdxShow.vue?vue&type=script&lang=js"
export * from "./veStuIdxShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b04a8",
  null
  
)

export default component.exports